import { createFileRoute } from "@tanstack/react-router";
import { DeploymentVersionEditorPage } from "@charphq/ui/components/layout/pages/DeploymentVersionEditorPage";

export const Route = createFileRoute("/deployments_/$deploymentId_/versions/$versionId")({
  component: DeploymentVersionEditorComponent,
});

function DeploymentVersionEditorComponent() {
  const { deploymentId, versionId } = Route.useParams();
  // Keyed by version: moving to another draft starts the editor fresh.
  return (
    <DeploymentVersionEditorPage
      key={versionId}
      deploymentId={deploymentId}
      versionId={versionId}
    />
  );
}
